module.exports = __webpack_public_path__ + "img/systemNameEN.3a1c0c36.svg";